module.exports = __webpack_public_path__ + "static/powered-by-mycrypto-80b3cefdbfbcd2ce90b2b96896c9cc6b.svg";